/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Share_Expires_HoursInputs */

const cs_documents_share_expires_hours = /** @type {(inputs: Documents_Share_Expires_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyprší za (hodiny)`)
};

const en_documents_share_expires_hours = /** @type {(inputs: Documents_Share_Expires_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires in (hours)`)
};

/**
* | output |
* | --- |
* | "Expires in (hours)" |
*
* @param {Documents_Share_Expires_HoursInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_share_expires_hours = /** @type {((inputs?: Documents_Share_Expires_HoursInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Share_Expires_HoursInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_share_expires_hours(inputs)
	return cs_documents_share_expires_hours(inputs)
});